const NAMESPACE = "projectFormStore";

const KEYS = {
    confirmDiscardUnsavedHeader: "confirmDiscardUnsavedHeader",
    confirmDiscardUnsavedMessage: "confirmDiscardUnsavedMessage",
    confirmDiscardUnsavedConfirmBtnLabel: "confirmDiscardUnsavedConfirmBtnLabel",
    confirmDiscardUnsavedCancelBtnLabel: "confirmDiscardUnsavedCancelBtnLabel"
};

const MESSAGES = {
    [KEYS.confirmDiscardUnsavedHeader]: {
        value: "Unsaved Changes Detected",
        comment: "Header for dialog warning user they may lose unsaved changes"
    },
    [KEYS.confirmDiscardUnsavedMessage]: {
        value: "You have unsaved changes on this form. If you continue, unsaved changes will be discarded. Otherwise, please cancel and save your changes before proceeding.",
        comment: "Message in dialog informing user they may lose unsaved changes"
    },
    [KEYS.confirmDiscardUnsavedConfirmBtnLabel]: {
        value: "Discard Changes and Continue",
        comment: "Label for button to confirm unsaved changes will be discarded"
    },
    [KEYS.confirmDiscardUnsavedCancelBtnLabel]: {
        value: "Cancel",
        comment: "Label for button to cancel discarding unsaved changes"
    }
};

export { NAMESPACE, KEYS, MESSAGES };
